export const REQUEST_PRE_EDITOR_DATA = 'REQUEST_PRE_EDITOR_DATA';
export const PRE_EDITOR_DATA_RECEIVED = 'PRE_EDITOR_DATA_RECEIVED';
